import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AnouncementService } from '../../services/anouncement.service';
import { Anouncement } from '../../models/anouncement';

@Injectable()
export class AnoucementDetailResolver implements Resolve<Anouncement> {
    constructor(
        private service: AnouncementService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Anouncement> {
        const id = route.paramMap.get('id');
        if (!id || !id.length) {
            this.router.navigate(['/home/list']);
            return Observable.of(null);
        }
        return this.service.getAnouncementDetail(id).take(1).map(res => {
            if (res) {
                return res;
            } else {
                this.router.navigate(['/home/list']);
                return null;
            }
        });
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/anouncement-detail/ano-detail.resolver.ts